import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    pollType: 'poll',
    question: '',
    description: '',
    allowMultiSelect: false,
    showResults: 'after-vote',
    resultStyle: 'bars',
    isClosed: false,
    closesAt: null,
    buttonText: '',
    layout: '',
    options: [],
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const pollSlice = createSlice({
  name: 'poll',
  initialState,
  reducers: {
    pollStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
        pollType: blockContent.pollType ?? 'poll',
        question: blockContent.question ?? '',
        description: blockContent.description ?? '',
        allowMultiSelect: blockContent.allowMultiSelect ?? false,
        showResults: blockContent.showResults ?? 'after-vote',
        resultStyle: blockContent.resultStyle ?? 'bars',
        isClosed: blockContent.isClosed ?? false,
        closesAt: blockContent.closesAt ?? null,
        buttonText: blockContent.buttonText ?? '',
        layout: blockContent.layout ?? '',
        options: blockContent.options ?? [],
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    pollClear: () => initialState,

    pollUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    pollUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    pollUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    pollUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { pollStore, pollClear, pollUpdateIsLoading, pollUpdateIsActive, pollUpdateBlockContent, pollUpdateBlockDesign } = pollSlice.actions;

export const selectPollIsLoading = (state) => state.poll.isLoading;

export const selectPollId = (state) => state.poll.id;
export const selectPollUID = (state) => state.poll.uid;
export const selectPollSID = (state) => state.poll.sid;

export const selectPollBlockContent = (state) => state.poll.blockContent;

export const selectPollSortItems = createSelector([selectPollBlockContent], ({ options }) => {
  return sortItems(options);
});

export const selectPollBlockDesign = (state) => state.poll.blockDesign;
export const selectPollButtonDesign = (state) => state.poll.buttonDesign;
export const selectPollItemDesign = (state) => state.poll.itemDesign;
export const selectPollContainerDesign = (state) => state.poll.containerDesign;

export default pollSlice.reducer;
